<template>
  <div>
    <div class="heading">Flights</div>

    <list-filter ref="listFilter"></list-filter>

    <div class="list-box">
      <table>
        <thead>
          <th>Flight ID</th>
          <th>Booking ID</th>
          <th>Created</th>
          <th>Passenger Name</th>
          <th>Departure</th>
          <th>Arrival</th>
          <th>Ground Transportation</th>
          <th></th>
          <th>Status</th>
          <!-- <th></th> -->
        </thead>
        <tbody>
          <tr v-for="(f, i) in flights.list" :key="i" v-show="!loading">
            <td><a :href="`#/flight/${f.id}`" target="_blank">{{f.id}}</a></td>
            <td>{{f.bookingId}}</td>
            <td>{{f.created}}</td>
            <td>{{f.paxName}}</td>
            <td>
              {{f.origin.airportCode}} -
              {{f.origin.airportName}}
            </td>
            <td>
              {{f.destination.airportCode}} -
              {{f.destination.airportName}}
            </td>
            <td class="rsvp-td">
              <a :href="`#/reservation/${f.rsvp1}`" target="_blank" v-if="f.rsvp1">{{f.rsvp1}}</a>
              <span v-if="f.rsvp1 && f.rsvp2">,</span>
              <span v-else>Opt Out</span>
              <a :href="`#/reservation/${f.rsvp2}`" target="_blank" v-if="f.rsvp2">{{f.rsvp2}}</a>
            </td>
            <td><span :class="['refundable', {'non': !f.isRefundable}]">{{f.isRefundable ? 'REFUNDABLE' : 'NON-REFUNDABLE'}}</span></td>
            <td><span :class="['status', f.status]">{{f.status}}</span></td>
            <!-- <td>
              <div class="button cta error xsmall" @click="showConfirm(f.id)">
                <span>CANCEL FLIGHT</span>
              </div>
            </td> -->
          </tr>

          <tr v-if="!loading && !flights.list.length">
            <td class="a-center loading" colspan="9">
              No flight found.
            </td>
          </tr>

          <tr v-if="loading">
            <td class="a-center loading" colspan="9">
              <i class="fas fa-spinner fa-spin"></i>
              Getting flight list...
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="fix-footer">
      <div class="row">
        <div class="small-3 columns per-page">
          <span>Displaying</span>
          <select v-model="perPage" :disabled="loading">
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          <span>per page</span>
        </div>

        <div class="small-6 columns page-data">
          <span v-show="flights.list.length > 0">
            Displaying
            <b>{{ pageData.start }}</b> - <b>{{ pageData.end }}</b> of
            <b>{{ pageData.max }}</b>
          </span>
        </div>

        <div :class="['small-3 columns pagination', {'move-right': enableSearchGlobal}]">
          <span>Page</span>
          <span :class="{'prevNext':true, 'disabled':currentPage === 1 || loading}" @click="prev">
            <i class="fas fa-chevron-left"></i>
          </span>
          <select v-model="currentPage" :disabled="loading">
            <option v-for="i in totalPage" :value="i" :key="i">{{i}}</option>
          </select>
          <span :class="{'prevNext':true, 'disabled':isLastPage || loading}" @click="next">
            <i class="fas fa-chevron-right"></i>
          </span>
        </div>
      </div>
    </div>

    <div :class="['lr-modal', {'hide': !showCxlConfirm}]">
      <div class="lr-box">
        Are you sure you want to cancel this fliight?
        <a class="button cta xsmall primary block" @click="cxlFLight">
          Yes, cancel this flight
        </a>
        <a class="button cta xsmall secondary block" @click="showCxlConfirm = false">
          No, i change my mind
        </a>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment-timezone'
import datepicker from 'vuejs-datepicker'
import listFilter from './Filter'

export default {
  name: 'flights',
  components: { datepicker, listFilter },
  data () {
    return {
      search: '',
      date: {
        from: '',
        to: ''
      },
      error: {
        from: false,
        to: false,
        message: ''
      },
      showCxlConfirm: false,
      selectedId: ''
    }
  },
  computed: {
    flights () { return this.$store.state.flights },
    loading: {
      get () { return this.flights.loading },
      set (x) {
        this.$store.commit('flights/setListData', {loading: x})
      }
    },
    perPage: {
      get () { return this.flights.perPage },
      set (x) {
        this.$store.commit('flights/setListData', {
          perPage: parseInt(x),
          currentPage: 1
        })
        this.getFlights()
      }
    },
    pageData () {
      let tableData = this.flights
      let start = (tableData.currentPage * tableData.perPage) - (tableData.perPage - 1)
      let end = tableData.currentPage * tableData.perPage
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      }
    },
    currentPage: {
      get () { return this.flights.currentPage },
      set (x) {
        this.$store.commit('flights/setListData', {currentPage: parseInt(x)})
        this.getFlights()
      }
    },
    isLastPage () { return (this.flights.currentPage * this.flights.perPage) >= this.flights.maxList },
    totalPage () { return Math.ceil(this.flights.maxList / this.flights.perPage) },
    enableSearchGlobal () { return this.$store.state.searchGlobal.enable }
  },
  methods: {
    getFlights () {
      if (this.$refs.listFilter) this.$refs.listFilter.getFlights()
    },
    showConfirm (id) {
      this.selectedId = id
      this.showCxlConfirm = true
    },
    cxlFLight () {
      let self = this
      self.showCxlConfirm = false
      self.$store.commit('global/setLoaderData', {show: true, message: ''})
      try {
        self.$sdk.post2(`${CONFIG.d2dGateway}/admin/d2d/cancel`, {
          token: self.$store.state.session.sessionToken,
          d2dId: this.selectedId,
        }, res => {
          self.$store.commit('global/setLoaderData', {show: false, message: ''})
          if (res.error) {
            this.$store.commit('global/setAlertData', {
              show: true,
              message: res.error.message
            })
            return
          }
          self.getFlights()
        })
      } catch (err) {
        self.$store.commit('global/setLoaderData', {show: false, message: ''})
        self.$store.commit('global/setAlertData', {
          show: true,
          message: err
        })
      }
    },
    prev () {
      if (this.currentPage === 1) { return }
      this.$store.commit('flights/setListData', {currentPage: this.currentPage - 1})
      this.getFlights()
    },
    next () {
      if (this.isLastPage) { return }
      this.$store.commit('flights/setListData', {currentPage: this.currentPage + 1})
      this.getFlights()
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.heading{
  margin-left: 50px;
  padding-left: 10px;
  height: 50px;
  background: #fff;
  border-bottom: 1px solid #ddd;
  line-height: 50px;
  color: #3F2975;
  font-size: 21px;
  font-weight: 600;
  text-transform: uppercase;
}

.list-box{
  overflow-y: auto;
  height: calc(100vh - 200px);
  border-top: 1px solid #ccc;

  thead {
    color: #8DA0A9;
    font-size: 12px;

    th {
      border-bottom: 1px solid #ccc;
      background-color: #f5f5f5;
      position: sticky;
      top: 0px;
    }
    .sortable{
      cursor: pointer;
      color: #333;
      text-decoration: underline;

      i{ margin-left: 2px; }
    }
  }
}
table {
  border-collapse: collapse;
  width: 100%;
}
th, td {
  padding: 5px;
  text-align: center;
}
tr{
  border-bottom: 1px solid #ddd;
  background: #f5f5f5;
  position: relative;

  &:nth-child(odd){
    background: #fbfbfb;
  }
  &:hover{
    box-shadow: 0 0 3px rgba(0,0,0, .3),
      inset 0 1px 1px #999;
    z-index: 2;
  }
  td{
    font-size: 14px;
    padding: 8px 5px;
  }
}
.refundable{
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  padding: 5px 10px;
  background: #41b430;
  color: #fff;
  border-radius: 4px;

  &.non{
    background: #ccc;
    color: #333;
  }
}
.status{
  font-size: 12px;
  color: #ccc;
  padding: 5px;
  background: #333;
  text-transform: uppercase;
  font-weight: 600;
  border-radius: 4px;

  &.PENDING{
    background: #e3b925;
    color: #fff;
  }
  &.UPCOMING{
    background: #ed922c;
    color: #fff;
  }
}

.fix-footer{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background: #eaeaea;
  border-top: 1px solid #aaa;
  font-size: 13px;
  color: #555;

  .row{ max-width: 100%; }
  select{
    max-width: 100px;
    height: 30px;
    padding: 5px;
  }
  .per-page{
    display: flex;
    line-height: 30px;
    padding: 10px 0;

    span{
      display: inline-block;
      margin: 0 10px;
    }
  }
  .page-data{
    text-align: center;
    line-height: 30px;
    padding: 10px 0;
  }
  .pagination{
    text-align: right;
    padding: 10px 10px;
    transition: all ease-in .2s;

    span{
      display: inline-block;
      margin-right: 5px;
    }
    select{
      height: 30px;
      vertical-align: middle;
    }
    .prevNext{
      margin: 0 2px;
      padding: 0 8px;
      border: 1px solid #bbb;
      background: #fff;
      cursor: pointer;
      vertical-align: middle;
      height: 30px;

      i{ line-height:28px; }
      &.disabled{
        opacity: .4;
        cursor: default;
      }
    }
    &.move-right{
      padding-right: 60px;
    }
  }
}

.lr-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  display: flex;
  justify-content: center!important;
  align-items: center!important;
  -webkit-transition: all 0.05s ease;
  -moz-transition: all 0.05s ease;
  -o-transition: all 0.05s ease;
  transition: all 0.05s ease;

  .lr-box {
    background: #fff;
    padding: 20px;
    border-radius: 6px;
    box-shadow: 3px 3px 2px rgba(0,0,0, .3);
    text-align: center;
    min-width: 200px;
    max-width: 300px;
    -webkit-transition: all 0.1s ease;
    -moz-transition: all 0.1s ease;
    -o-transition: all 0.1s ease;
    transition: all 0.1s ease;
  }
  .lr-alert-msg{
    margin-bottom: 20px;
    color: #45505b;
  }
  &.hide {
    z-index: -1;
    opacity: 0;

    .lr-box{
      transform: scale(90%) translateY(30px);
    }
  }
  a{
    margin-top: 10px;
  }
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .3s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Flights/index.vue